import { render, staticRenderFns } from "./LLMConfiguration.vue?vue&type=template&id=2bb51480&scoped=true"
import script from "./LLMConfiguration.vue?vue&type=script&lang=js"
export * from "./LLMConfiguration.vue?vue&type=script&lang=js"
import style0 from "./LLMConfiguration.vue?vue&type=style&index=0&id=2bb51480&prod&scoped=true&lang=scss"
import style1 from "./LLMConfiguration.vue?vue&type=style&index=1&id=2bb51480&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb51480",
  null
  
)

export default component.exports